import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import { Wrapper, StyledContainer, Content, Img } from './styles';

const HeroBanner = ({ data }) => {
  if (!data) return null;

  const {
    headingHtml,
    subheadingHtml,
    bannerCTAText,
    bannerCTA: { url: href },
    imageMobileHero: { altTag },
    imageHero,
    imageMobileHero,
    imageHeroSharp,
    imageMobileHeroSharp,
    ctaType,
    ariaLabel,
    queryString,
    lang,
  } = data;
  return (
    <Wrapper id="hero" background={imageHero ? imageHeroSharp.publicURL : null}>
      <StyledContainer className={['auto-margin']}>
        <Content>
          {ReactHtmlParser(headingHtml)}
          {ReactHtmlParser(subheadingHtml)}
          <Link
            className={`${ctaType} auto-size`}
            to={href}
            ariaLabel={ariaLabel}
            queryString={queryString}
            lang={lang}
          >
            {bannerCTAText}
          </Link>
        </Content>
        <Img
          src={imageMobileHero ? imageMobileHeroSharp : imageHeroSharp}
          alt={altTag}
        />
      </StyledContainer>
    </Wrapper>
  );
};

HeroBanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

HeroBanner.defaultProps = {};

export default HeroBanner;
